import PracticeMascotDialog from 'core/chatbot/components/atoms/PracticeMascotDialog/PracticeMascotDialog';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * KcPracticeExitDialog - Confirmation shown when a student leaves a volatile single-KC practice
 * launched from "Áreas de mejora" (TANAI-2087). Unlike its sibling ExitPracticeDialog, the
 * session cannot be resumed, so there is nothing to "save for later": it offers a single
 * "Salir" CTA (`onExit`) that discards the practice and returns to "Mi progreso", while the
 * header X (`onClose`) just dismisses the dialog and keeps the student practising. The copy
 * makes the trade-off explicit — mastery progress is kept, this practice is not.
 *
 * The mascot + message + single CTA layout is the shared PracticeMascotDialog atom, so this
 * component is only the copy of this dialog (the StudyBuddy "look up" variant) and its wiring:
 * the discard, the analytics and the route live in usePracticeExitFlow.
 */

type KcPracticeExitDialogProps = {
  isDiscarding?: boolean;
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
};

function KcPracticeExitDialog({ isDiscarding = false, isOpen, onClose, onExit }: Readonly<KcPracticeExitDialogProps>): JSX.Element {
  const { t } = useTranslation(['chatbot']);

  return (
    <PracticeMascotDialog
      body={t('kc_practice_exit_dialog_body')}
      ctaText={t('kc_practice_exit_cta')}
      isLoading={isDiscarding}
      isOpen={isOpen}
      mascot="look-up"
      onClose={onClose}
      onSuccess={onExit}
      title={t('kc_practice_exit_dialog_title')}
    />
  );
}

export default KcPracticeExitDialog;
